const { SEPHORA_URL: { DESKTOP } } = require('components/constants');
const { TemplatesToUrlMapping } = require('constants/TemplatesToUrlMapping');
const bccUtil = require('utils/BCC');
const LocationUtils = require('utils/Location');
const store = require('Store');
const UrlUtils = require('utils/Url');
const UserActions = require('actions/UserActions');
const PageTemplateType = require('constants/PageTemplateType');


const SpaUtils = {
    replaceContentAreaTargeters: function (currentData = {}, newData = {}) {
        let allPageTargeterNames = Sephora.targetersToInclude.substr('?includeTargeters='.length);
        allPageTargeterNames = decodeURIComponent(allPageTargeterNames).split(',');

        // remove old content area targeters
        const currentTargeterNames = bccUtil.extractTargeters(currentData);
        for (let targeterName of currentTargeterNames) {
            let index = allPageTargeterNames.indexOf(targeterName);
            if (index !== -1) {
                allPageTargeterNames.splice(index, 1);
            }
        }

        // add new content area targeters
        const newTargeterNames = bccUtil.extractTargeters(newData);
        allPageTargeterNames = allPageTargeterNames.concat(newTargeterNames);
        Sephora.targetersToInclude = bccUtil.buildTargetersQueryParams(allPageTargeterNames);
    },

    updateUserFull: function (data, productPageData = {}, options = {}) {
        const currentUser = Sephora.Util.getCurrentUser();
        const basketCache = Sephora.Util.getBasketCache(currentUser);
        const userInfoCache = Sephora.Util.getUserInfoCache();

        if (Sephora.Util.shouldGetUserFull(basketCache, currentUser, userInfoCache)) {
            store.dispatch(UserActions.getUserFull(
                productPageData,
                undefined,
                undefined,
                undefined,
                options.hideLoader || false
            ));
        } else if (Sephora.Util.shouldGetTargeters()) {
            store.dispatch(UserActions.getUserFull(
                productPageData,
                null,
                {
                    includeApis: 'targetersResult,targetedPromotion'
                },
                undefined,
                options.hideLoader || false
            ));
        }
    },

    resetCertona: function () {
        require('services/Certona')();
    },

    resetDigitalData: function() {
        digitalData.page.renderTime = null;
        digitalData.page.startSpaLoad = performance.now();
        digitalData.product = [];
        digitalData.page.attributes.previousPageData.recInfo = {};
        digitalData.page.attributes.featureVariantKeys = [];
        digitalData.lastRefresh = 'soft';
    },

    resetTestAndTarget: function () {
        const Events = require('utils/framework/Events');
        Sephora.Util.InflatorComps.services.loadEvents[Events.TestTargetServiceReady] = false;
        require('services/TestTarget')();
    },

    resetAddStructure: function () {
        require('services/AddStructure')();
    },

    updateHeaderTags: data => {
        if (!data?.content) {
            return;
        }

        const {
            seoCanonicalUrl,
            seoMetaDescription,
            seoTitle
        } = data.content;
        document.title = SpaUtils.getPageTitle(seoTitle, Sephora.renderedData.template);

        if (seoTitle) {
            document.getElementById('metaOgTitle')?.setAttribute('content', seoTitle);
        }

        if (seoMetaDescription) {
            document.getElementById('metaDescription')?.setAttribute('content', seoMetaDescription);
            document.getElementById('metaOgDescription')?.setAttribute('content', seoMetaDescription);
        }

        if (seoCanonicalUrl) {
            const url = UrlUtils.getLink(seoCanonicalUrl && DESKTOP + seoCanonicalUrl);
            document.getElementById('seoCanonicalUrl')?.setAttribute('href', url);
            document.getElementById('metaOgUrl')?.setAttribute('content', url);
        }
    },

    getPageTitle: (seoTitle, template) => {
        let title = 'Sephora';

        if (seoTitle) {
            title = seoTitle;
        } else if (LocationUtils.getPageTitle(template)) {
            const postfix = template.indexOf('Community') === -1 ? ' | Sephora' : '';
            title = `${LocationUtils.getPageTitle(template)}${postfix}`;
        }

        return title;
    },

    isSpaNavigation: url => SpaUtils.isActiveSpaPage && SpaUtils.isSpaUrl(url),

    get isActiveSpaPage() {
        return Sephora.isSPA && Sephora.configurationSettings.spaEnabled && SpaUtils.isProductSpaActive();
    },

    isProductSpaActive: () => {
        const { page: { templateInformation: { template } } } = store.getState();
        return template === PageTemplateType.ProductPage ? Sephora.configurationSettings.spaEnabledProduct : true;
    },

    isSpaUrl: pageUrl => TemplatesToUrlMapping.some(({ urls }) => urls.some(({ ulr, isSpa }) => (isSpa && (
        pageUrl.startsWith(ulr) ||
        pageUrl.startsWith(`/ca/fr${ulr}`) ||
        pageUrl.startsWith(`/ca/en${ulr}`)
    )))),

    getPageTemplate: pageUrl => {
        const { template = '' } = TemplatesToUrlMapping.find(({ urls }) => urls.some(({ ulr }) => (
            pageUrl.startsWith(ulr) ||
            pageUrl.startsWith(`/ca/fr${ulr}`) ||
            pageUrl.startsWith(`/ca/en${ulr}`)
        ))) || {};

        return template;
    }
};

module.exports = SpaUtils;
